import { render, staticRenderFns } from "./ApplicationPdfEditor.vue?vue&type=template&id=4bd0a98d&scoped=true&"
import script from "./ApplicationPdfEditor.vue?vue&type=script&lang=js&"
export * from "./ApplicationPdfEditor.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationPdfEditor.vue?vue&type=style&index=0&id=4bd0a98d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd0a98d",
  null
  
)

export default component.exports